import { getAuthFormData } from 'helpers/AuthHelper';
import * as cTypes from 'config/ConfigTypes';

export const checkUser = ({ user, getState }) => {
    const configObjects = getState().config.configObjects;
    const authObjects = getState().auth.authObjects;
    let formData = getAuthFormData({ authForm: cTypes.REGISTER_USER, configObjects, authObjects });
    let showData = [];
    formData.forEach(item => {
        if (item.children) {
            let children = [];
            item.children.forEach(el => {
                if (el.required && !user[el.field]) {
                    children.push(el);
                }
            })
            if (children.length) {
                item.children = children;
                showData.push(item);
            }
        } else {
            if (!item.notFillIn && item.required && !user[item.field]) showData.push(item);
        }
    })
    console.log("LOGS: fillData", showData);
    if (showData && showData.length > 0) return showData;
    return null;
}

export const verifyUserInputs = ({ userInputs }) => {
    for (let i in userInputs) {
        if (i.startsWith(cTypes.ONLY_REPEAT)) delete userInputs[i];
    }
    return userInputs;
}

